import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { baseRest } from './globalVars.js';

import '@fortawesome/fontawesome-free/js/all.js';

import Axios from 'axios';
Vue.prototype.$http = Axios;

const isProd = process.env.NODE_ENV === 'production';

import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
	id: ['UA-36754426-31'],
	router,
	/*debug: {
    enabled: !isProd,
    disabled: isProd,
  }*/
});

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
//

router.beforeEach((to, from, next) => {
	if (to.name === 'home') {
		store.dispatch('changeHome', true);
	} else {
		store.dispatch('changeHome', false);
	}
	if (to.name != 'home') {
		//return this.$store.getters.duvidas
		store.dispatch('updateLoad', false);
		let rota;
		switch (to.params.categoria) {
			case 'usabilidade':
				rota = 'nma-usabilidade';
				store.dispatch('updateTituloDúvidas', 'Uso da Plataforma');
				break;
			case 'financeiro':
				rota = 'nma-pagamento';
				store.dispatch('updateTituloDúvidas', 'Financeiro');
				break;
			case 'conteudo':
				rota = 'nma-conteudo';
				store.dispatch('updateTituloDúvidas', 'Conteúdo');
				break;
			case 'legal':
				rota = 'nma-legal';
				store.dispatch('updateTituloDúvidas', 'Jurídico');
				break;
			case 'afiliados':
				rota = 'nma-afiliados';
				store.dispatch('updateTituloDúvidas', 'Afiliados');
				break;
			default:
				rota = 'nma-usabilidade';
				store.dispatch('updateTituloDúvidas', 'Uso da Plataforma');
				break;
		}
		Axios.get(baseRest + '?catduvida=' + rota)
			.then((res) => {
				store.dispatch('updateDuvidas', res.data);
			})
			.then(() => {
				store.dispatch('updateLoad', true);
			});
	}
	next();
});
